import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

// common
import { UserDetail } from 'modules/account/services/useGetAccountInfo';
import { KEYS_QUERY } from 'common/constants';
import { handleException } from 'modules/account/detail/helpers/utils';
import { type AppState } from '../../../redux/store';
import useService from 'common/hook/useService';

const useGetUserInfo = () => {
  const userId = useSelector(({ auth: { userInfo } }: AppState) => (userInfo ? userInfo.id : ''));
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.userDetail, userId],
    queryFn: async () => {
      try {
        if (!service) return null;

        const res = await service.UserController_getData();
        return res as UserDetail;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useGetUserInfo;
